module.exports = __webpack_public_path__ + "static/media/POTE_1KG.44fc5a26.png";